export const APP_IDS = {
  INSPIRO_IOS: '65ddabb51b4bc054069579bc',
  INSPIRO_ANDROID: '65ddac321b4bc05406957ab0',
  CLOCKLY: '642f20847e00fd082f3a9bd2',
};

export const INSPIRO_APPS = [APP_IDS.INSPIRO_ANDROID, APP_IDS.INSPIRO_IOS];
